import React from 'react'
import { Alert, Block, BlockGroup, Button, Dialog, Input, Text } from '@mote/ui'

import styled from 'styled-components'
import { FileIcon } from '@mote/assets/icons'
import { useConfirmCSVMutation } from '@mote/api'

const PROCEED_KEYWORD = 'I UNDERSTAND'

export const ImportSuccessConfirmationDialog = ({
  onImportConfirmation,
  onDialogDismissal,
  onShowPreviousScreen,
  uploadMeta = { jobId: '13', userCount: 15000, fileName: 'test.csv' }
}) => {
  const {
    mutate: confirmCSVImport,
    data,
    error,
    loading,
    fetched
  } = useConfirmCSVMutation()
  const [inputValue, setInputValue] = React.useState()

  function handleInputChange(e) {
    setInputValue(e.target.value.toUpperCase())
  }

  async function handleImportCSVConfirmation() {
    await confirmCSVImport({ variables: { jobId: uploadMeta.jobId } })
  }

  React.useEffect(() => {
    if (!fetched || (fetched && error)) return

    if (data && !data.success) return

    onImportConfirmation()
  }, [fetched, error, data, onImportConfirmation])

  return (
    <Dialog isOpen onClose={onDialogDismissal} hasBackdrop={false}>
      <Dialog.Heading>Import CSV</Dialog.Heading>
      <Dialog.Content>
        <Block align='center' gap={16} margin='0 0 33px 0'>
          <Alert type='success' message='Ready to go!' />

          <BlockGroup layout='horizontal' justify='space-between' spreadX>
            <Block layout='horizontal' gap={8}>
              <FileIcon color='#000000' />

              <Block>
                <Text tag='p' fontWeight={500} fontSize={14}>
                  {uploadMeta.fileName}
                </Text>
                <Text tag='p' color='#646F7B' fontSize={14}>
                  {uploadMeta.userCount} items
                </Text>
              </Block>
            </Block>

            <Button
              size='sm'
              text='Remove'
              variant='link'
              onClick={onShowPreviousScreen}
            />
          </BlockGroup>
        </Block>

        <Block gap={10}>
          <Text tag='p' fontSize={14} fontWeight={700}>
            Confirm import?
          </Text>
          <Text tag='p' fontSize={14} color='#646F7B'>
            By importing this CSV you will overwrite all existing users and
            entries. Only do this if you are completely sure.
          </Text>
        </Block>

        <Block gap={9}>
          <Text tag='small' fontSize={12} styles={{ marginTop: 15 }}>
            Confirm by typing <GreenText>I UNDERSTAND</GreenText> below
          </Text>
          <Input
            onChange={handleInputChange}
            placeholder='I UNDERSTAND'
            value={inputValue}
          />
          {data && !data.success && <Alert message={data.failureReason} />}
        </Block>
      </Dialog.Content>

      <Dialog.ButtonGroup alignment='flex-start'>
        <Button
          text={loading ? 'Importing...' : 'Import CSV'}
          size='sm'
          onClick={handleImportCSVConfirmation}
          disabled={inputValue !== PROCEED_KEYWORD || loading}
        />
        <Button
          variant='secondary'
          text='Cancel'
          size='sm'
          disabled={loading}
          onClick={onDialogDismissal}
        />
      </Dialog.ButtonGroup>
    </Dialog>
  )
}

const GreenText = styled.span`
  font-weight: 700;
  color: #57c96a;
`
